import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { AccountOverviewService } from '../../account-overview.service';

@Component({
  selector: 'app-offers-banner',
  templateUrl: './offers-banner.component.html',
  styleUrl: './offers-banner.component.scss'
})
export class OffersBannerComponent implements OnInit, OnDestroy {
  offersEligible: boolean = false;
  offerAccepted: boolean = false;
  isBannerVisible: boolean = true;
  private offerEligibilitySub: Subscription;

  constructor(
    private readonly acService: AccountOverviewService,
    private readonly cdr: ChangeDetectorRef,
    private readonly _dataLayerService: DataLayerService,
    private readonly router: RoutingService
  ){}

  ngOnInit(): void {
    this.offerEligibilitySub = this.acService.offerEligibility.subscribe(res => {
      if (res) {
        this.offersEligible = res.offersEligible;
        this.offerAccepted = res.offersAccepted;
        this.cdr.detectChanges();
      }
    })
  }

  onBannerDisplayed(): void {
    const data = {
      promotion_name: "app-offers-banner",
      creative_slot: "body_top"
    }
    this._dataLayerService.addtoDataLayer('banner_displayed', data);
  }

  onBannerClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    const clickedClose = target.closest('button[aria-label="close offers banner"]');
    const clickedCTA = target.closest('a.btn-secondary');

    // Only trigger onViewOffer() if user didn't click close or CTA directly
    if (!clickedClose && !clickedCTA) {
      this.onViewOffer();
    }
  }

  onViewOffer(): void {
    const data = {
      promotion_name: "app-offers-banner",
      creative_slot: "body_top"
    }
    this._dataLayerService.addtoDataLayer('banner_link_clicked', data);
    this.router.goByUrl("/offers");
  }

  closeBanner(): void {
    this.isBannerVisible = false;
  }

  ngOnDestroy(): void {
    this.offerEligibilitySub.unsubscribe();
  }
}
